"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteLabelValueDialogBody = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const DELETE_LABEL_VALUE_TEST_ID = 'delete-label-value-dialog-body';
const deleteLabelDialogPadding = 100;
function DeleteLabelValueDialogBody(props) {
    const { category, name } = props;
    const { data } = (0, client_1.useQuery)(catalog_queries_1.LabelValueDeleteCountsDocument, {
        variables: { labelValueName: name },
    });
    let deleteCount = 0;
    if (data && category === 'WARNING') {
        deleteCount = data.dataQualityWarningsConnection.totalCount;
    }
    else if (data) {
        deleteCount = data.genericLabelsConnection.totalCount;
    }
    return (deleteCount === 0
        ? (react_1.default.createElement(DeleteLabelValueDialogBodyDiv, null, catalog_messages_1.Messages.DeleteLabelValueMessageWithZeroAsset()))
        : (react_1.default.createElement(DeleteLabelValueDialogBodyDiv, null, catalog_messages_1.Messages.DeleteLabelValueMessage({ NAME: name, ITEM_COUNT: catalog_messages_1.Formatters.formatCount(deleteCount) }))));
}
exports.DeleteLabelValueDialogBody = DeleteLabelValueDialogBody;
const DeleteLabelValueDialogBodyDiv = (0, vizportalclient_common_components_1.divWithStyle)(DELETE_LABEL_VALUE_TEST_ID, {
    paddingBottom: deleteLabelDialogPadding,
});
//# sourceMappingURL=DeleteLabelValueDialogBody.js.map